import React from 'react';
import {
  NextArrow,
  PrevArrow,
} from '../../../components/molecules/CustomArrows';

export const settings = {
  dots: false,
  infinite: false,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  // lazyLoad: 'progressive',
  initialSlide: 0,
  nextArrow: <NextArrow color="default" />,
  prevArrow: <PrevArrow color="default" />,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        useTransform: false,
        useCSS: false,
        touchMove: false,
      },
    },
  ],
};
